define('widgets/slides',[
	'jquery',
	'modules/page',
	'lib/jquery-ui/widget',
	'lib/jquery.mousewheel'
], function ($, page) {

	return $.widget('muse.slides', {

		options: {
			wrap: '.wrap',
			slide: '.slide',
			nav: '.nav.horizontal',
			shortcuts: true,
			resize: false,
			className: 'slides',
			tolerance: 5,
			hash: true
		},

		_initialized: false,

		_create: function () {

			this.element.addClass(this.option('className'));

			this.$wrap = this.element.children(this.option('wrap'));
			this.$slides = this.$wrap.children(this.option('slide'));

			this.setCurrent();

			this.$nav = this.element.find(this.option('nav'));
			this._on(this.$nav, {
				'click a': 'onNavClick'
			});

			if (this.option('hash')) {
				this._on(page.$win, {
					hashchange: 'onHashChange'
				});
				$(window).trigger('hashchange');
			}

			this._on({
				mousewheel: 'onMouseWheel',
				scroll: 'onScroll',
			});

			if (this.option('shortcuts'))
				this._on(page.$win, {
					'keydown': $.proxy(this, 'onKeyDown')
				});

			if (this.option('resize'))
				this._on(page.$win, {
					'resized': $.proxy(this, 'onResize')
				});

			this._super();

		},

		_init: function () {

			this.updateNav();
			this.resize();

			this._initialized = true;

		},

		resize: function () {

			var total = 0;

			console.log('resize slides');

			this.resizing = true;

			// this.$slides.width('');
			// this.$wrap.width('100%');
			this.$wrap.removeClass('layout');

			this._trigger('beforeresize');

			// this.$slides.each(function () {

			// 	var $el = $(this);

			// 	total += $el.outerWidth(true);
			// 	$el.width($el.width());

			// });

			// this.$wrap.width(total);
			this.$wrap.addClass('layout');

			this.goTo(this.$current);

			this._trigger('afterresize');

			var x = 0;
			this.position = this.$slides.map(function () {
				var l = x;
				x +=$(this).outerWidth(true);
				return l;
			});
			console.log('position', this.position);

			this.resizing = false;

		},

		onNavClick: function (e) {

			var $el = $(e.currentTarget);

			this.browse($el.hasClass('prev') ? 'prev' : 'next');

			e.preventDefault();

		},

		browse: function (direction) {

			var $target;

			direction = direction || 'next';
			$target = this.$current[direction]('.slide');

			if (!$target.length) return;

			return this.goTo($target);

		},

		goTo: function ($target) {

			var left = (typeof $target == 'number') ? $target : this.$wrap.offset().left - $target.offset().left,
				delta = Math.abs(this.element[0].scrollLeft + left);

			console.log('goTo', left, delta, (300 + delta / 3));

			if (typeof this.scroll == 'undefined')
				this.scroll = this.element[0].scrollLeft;

			if (this.scroll === left) return this;
			this.scroll = left;

			this.element
				.stop()
				.animate({
					'scrollLeft': -left
				}, {
					duration: this.resizing ? 0 : (300 + delta / 3),
					start: $.proxy(function () {
						this.animating = true;
					}, this),
					done: $.proxy(function () {
						setTimeout($.proxy(function () {
							this.animating = false;
						}, this), 100);
					}, this)
				});

			if (typeof $target == 'object')
				this.setCurrent($target);

			this.updateNav();

			$.publish('slide');

			return this;

		},

		updateNav: function () {

			this.$nav.find('.prev').toggleClass('enabled', this.hasPrev());
			this.$nav.find('.next').toggleClass('enabled', this.hasNext());

		},

		hasPrev: function () {

			return this.getIndex() > 0;

		},

		hasNext: function () {

			return this.getIndex() < (this.$slides.length - 1);

		},

		getIndex: function ($el) {

			$el = $el || this.getCurrent();
			return this.$slides.index($el);

		},

		getCurrent: function () {

			return this.$current;

		},

		setCurrent: function ($el) {

			var $target = $el || this.$slides.first();
				id = $target && $target.attr('id');

			this.$current = $target;
			if (!this.option('hash')) return;

			if (this.currentId != id)
				location.hash = id ? '!' + id : '';

			this.currentId = id;

		},

		onKeyDown: function (e) {

			switch (e.keyCode) {
				case 37:
					this.browse('prev');
					e.preventDefault();
					break;
				case 39:
					this.browse('next');
					e.preventDefault();
					break;
			}

		},

		onResize: function (e) {

			this.resize();

		},

		onMouseWheel: function(e) {

			if (this.element[0].scrollLeft !== 0 || (e.deltaY >= 0 && e.deltaX >= 0)) {
				e.stopPropagation();
			}

			if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;

			console.log('scroll', e);
			this.element[0].scrollLeft -= (e.deltaY * 2);

			e.preventDefault();

		},

		onScroll: function () {

			if (this.animating) return;

			this.checkPosition();
			this.updateNav();

		},

		checkPosition: function (left) {

			var i = 0,
				current = 0,
				tolerance = this.option('tolerance'),
				$el;

			left = left || this.element[0].scrollLeft;
			// console.log('onScroll', left);

			for (; i < this.$slides.length; i++) {

				if (this.position[i] <= (left + tolerance))
					current = i;
				else break;

			}

			$el = this.$slides.eq(current);
			this.setCurrent($el);

		},

		onHashChange: function (e) {

			var $el = this.element.find(location.hash.replace('#!', '#'));

			if (!location.hash || !$el.length) return;

			if (!this._initialized)
				this.$current = $el;
			else if (this.$current[0] != $el[0])
				this.goTo($el);

		}


	});

});
